<div *ngIf="icon()" class="xp-empty-state__icon-wrap">
	<mat-icon class="xp-empty-state__icon">{{ icon() }}</mat-icon>
</div>
<img *ngIf="imageSrc()" class="xp-empty-state__image" [src]="imageSrc()" alt="" />
<div *ngIf="title()" class="xp-empty-state__title">{{ title() }}</div>
<div *ngIf="description()" class="xp-empty-state__description">{{ description() }}</div>
<ng-content></ng-content>
